import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import JoditEditor from "jodit-react";
import { IDS } from "../../../utils/common";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, Select2Data } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [videoFile, setVideoFile] = useState(null);
  const [oldImage, setOldImage] = useState("");

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      content: "",
      video: null,
    },
  });

  const selectedVideo = watch("video");

  const GetEditData = async () => {
    try {
      const response = await getData(`/admin/setting/about-us/${id}`);

      if (response?.success) {
        reset({
          content: response?.data?.content || "",
          video: null,
        });

        setOldImage(response?.data?.video || "");
        setVideoFile(null);
      }
    } catch (error) {
      console.error("Get About Us Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      GetEditData();
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();

      DataToSend.append("content", data?.content || "");

      DataToSend.append("video", data.video[0]);

       for (const [key, value] of DataToSend.entries()) {
      console.log(key, value);
    }

      const response = await putData(
        `/admin/setting/about-us/${id}`,
        DataToSend,
      );

      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response?.data,
        });
      } else {
        setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      setTimeout(() => {
        setShowModal({
          code: 0,
          message: "",
        });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error("Update About Us Error:", error);
    }
  };

  // const handleVideoChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setValue("video", e.target.files);
  //     setVideoFile(file);
  //   }
  // };

  const handleVideoChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setVideoFile(file);
      setValue("video", e.target.files, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit About Us
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Content</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Controller
                          name="content"
                          control={control}
                          rules={{
                            required: "Content is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              // onBlur={() => {
                              //   onBlur();
                              //   trigger("content");
                              // }}
                              onChange={onChange}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.content && (
                        <span className="text-danger">
                          {errors.content.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <div className="main-form-section mt-3">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">Upload Image</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      className={classNames("", {
                        "is-invalid": errors?.video,
                      })}
                      {...register("video")}
                    />

                    {errors.video && (
                      <span className="text-danger">
                        {errors.video.message}
                      </span>
                    )}
                    {errors.video && (
                      <span className="text-danger">
                        {errors.video.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Image Preview</Form.Label>

                  {selectedVideo?.[0] ? (
                    <img
                      src={URL.createObjectURL(selectedVideo[0])}
                      alt="New Preview"
                      width="100%"
                      height="250"
                      style={{
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  ) : oldImage ? (
                    <img
                      src={`${process.env.REACT_APP_BASE_URL.replace("/api/v1", "")}${oldImage}`}
                      alt="About Us"
                      width="100%"
                      height="250"
                      style={{
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  ) : (
                    <p className="text-muted">No image available</p>
                  )}
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
